import { z } from 'zod'
import { DestinationSchema } from '../location'
import { MembershipSchema } from '../members'
import { PriceRangeQuerySchema, SortingSchema } from '../common/query-params'

const ActivityTimeWindowSchema = z.object({
  closeMin: z.boolean().optional(),
  closeMax: z.boolean().optional(),
  minDuration: z.number().optional(),
  maxDuration: z.number().optional(),
  uom: z.string().optional(),
  unit: z.string().optional(),
})

const ExperienceFilterArraySchema = z.preprocess((val: unknown) => {
  if (typeof val === 'string') {
    return val.split(',')
  }
  return val
}, z.string().array())

const ExperienceFilterSchema = z.object({
  priceRange: PriceRangeQuerySchema.optional(),
  accessibilities: ExperienceFilterArraySchema.optional(),
  specials: ExperienceFilterArraySchema.optional(),
  timeWindow: z.string().optional(),
})

export const ExperienceSearchParamsSchema = z.object({
  dates: z.object({
    startDateTime: z.string().min(1),
    endDateTime: z.string().min(1),
  }),
  destination: DestinationSchema,
  sorting: SortingSchema,
  page: z
    .string()
    .default('1')
    .transform((val) => Number(val)),
  shoppingFilter: ExperienceFilterSchema.optional(),
  membership: MembershipSchema.optional(),
  scrollRef: z.string().optional(),
})

export const ExperienceFormSchema = z.object({
  searchString: z.string().optional(),
  startDateTime: z.date(),
  endDateTime: z.date().nullable(),
  destination: DestinationSchema,
})

export type ExperienceSearchParams = z.infer<typeof ExperienceSearchParamsSchema>
export type ExperienceFilterQuery = z.infer<typeof ExperienceFilterSchema>
export type ExperienceForm = z.infer<typeof ExperienceFormSchema>
export type ActivityTimeWindow = z.infer<typeof ActivityTimeWindowSchema>
